import { days } from "../../../../shared/data/days";
import { months } from "../../../../shared/data/months";


export const translateCalendarHorizontal = () => {
    const daysLabel = document.querySelectorAll("[class*=DatePicker_dayLabel__]");
    const monthsLabel = document.querySelectorAll("[class*=DatePicker_monthYearLabel__]");

    for (const label of daysLabel) {
        const findDay = days.find(x => x.dayEn === label.innerHTML);
        if(findDay) {
            label.innerHTML = findDay.dayEs;
        }
    }

    for (const label of monthsLabel) {
        const findMonth = months.find(x => label.innerHTML.includes(x.monthEn));
        const replaceMonth = label.innerHTML.replace(findMonth?.monthEn, findMonth?.monthEs)
        label.innerHTML = replaceMonth;
    }
}